import type { LSChildAccount } from '../../shared/types/child-account';
import { useStore } from '~/composables/useStore';

interface UseChildAccountStoreOptions {
	key?: string;
}

export function useChildAccountStore(options: UseChildAccountStoreOptions = {}) {
	const { key = 'child-accounts' } = options;
	const { $api } = useNuxtApp();

	const { getFullUrl } = useStaticMode();

	// TODO: add an LSChildAccountSchema and pass it as `schema` so this read is
	// validated at the boundary like the others (currently trusts the response).
	const { data, loading, error, refresh } = useStore<LSChildAccount[]>({
		key,
		server: true,
		immediate: false,
		fetcher: () =>
			$api<LSChildAccount[]>(getFullUrl('/api/Auth/GetUsersChildAccounts'), {
				method: 'GET',
				credentials: 'include',
			}),
	});

	return {
		data,
		loading,
		fetching: loading,
		error,
		refresh,
	};
}
